import { StorageListV2Translations } from "../../../pt-BR/place/storage/storage-list-v2";

export const storageListV2: StorageListV2Translations = {
	layout: {
		title: "Inventarios",
	},
	header: {
		searchPlaceHolder: "Buscar por nombre del inventario",
		createStorage: "Crear Inventario",
		storageTypeFilter: {
			local: "Local",
			central: "General",
			all: "Todos los inventarios (central y local)",
			ariaLabel: "Seleccionar el tipo de inventario",
		},
	},
	indicators: {
		storagesCount: {
			label: "Inventarios registrados",
		},
		productsCount: {
			label: "Productos en inventario",
		},
		totalCost: {
			label: "Costo en inventarios",
		},
		zeroedProductsCount: {
			label: "Productos agotados",
			seeProducts: "Ver productos",
		},
		productsWithoutUnitCostValue: {
			label: "Productos custo zerado",
			seeProducts: "Ver productos",
		},
	},
	list: {
		productsCount_zero: "{{count}} productos",
		productsCount_one: "{{count}} producto",
		productsCount_other: "{{count}} productos",
		createdAt: "Creado el {{date}}",
		productsCount: "En inventario",
		totalCost: "Costo total",
		attachedBars_zero: "{{count}} bares vinculados",
		attachedBars_one: "{{count}} bar vinculado",
		attachedBars_other: "{{count}} bares vinculados",
		seeBars: "Ver bares",
		noBarsLinked: "Ningún bar vinculado",
	},
	attachedBarsDrawer: {
		drawerTitle: "Bares vinculados",
		title: "Bares",
		description: "Consulta dónde tu producto está disponible para consumo",
		linkedBarsLabel: "Bares vinculados",
		barDescription: {
			storage: "Inventario",
			printersIps: "IPs de las impresoras",
		},
	},
	irregularProductsDrawer: {
		filters: {
			storage: "Inventario",
			selectStorage: "Seleccionar inventario",
		},
		quantity: {
			title: "Productos con cantidad cero",
			description: "Actualice sus productos con cantidad cero",
			save: "Actualizar cantidad",
		},
		unitCostValue: {
			title: "Productos con costo unitario cero",
			description: "Actualice sus productos con costo unitario cero",
			save: "Actualizar costo unitario",
		},
		table: {
			columns: {
				product: "Producto",
				fiscalCode: "SKU",
				storage: "Inventario",
				quantity: "Cantidad",
				unitCostValue: "Costo unitario",
				totalCost: "Costo total",
			},
		},
		successUpdateIrregularProducts: "Productos actualizados con éxito",
	},
	actions: {
		editStorage: "Editar inventario",
		deleteStorage: "Eliminar inventario",
	},
	persistStorageDrawer: {
		title: {
			create: "Crear inventario",
			edit: "Editar inventario",
		},
		form: {
			name: {
				label: "Nombre del inventario",
				placeholder: "Nombre del inventario",
				error: "Nombre del inventario es obligatorio",
				maxLengthError:
					"El nombre del inventario debe tener como máximo {{maxLength}} caracteres",
				nameInUse: "Nombre del inventario ya en uso",
			},
			type: {
				label: "Tipo de inventario",
				options: {
					local: "Local",
					central: "General",
				},
			},
		},
		actions: {
			submitEdit: "Guardar cambios",
			submitCreate: "Crear Inventario",
		},
		successEditModal: "Inventario editado con éxito",
		successCreateModal: "Inventario creado con éxito",
	},
	modalDelete: {
		title: "Eliminar Inventario",
		warningMessage: '¿Está seguro de que desea eliminar el inventario "{{storageName}}"?',
		warningMessageStrong: "Esta acción no puede ser deshecha.",
		submit: "Eliminar",
		successDeleteModal: "Inventario eliminado con éxito",
	},
};
